import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PromoBanner from './components/PromoBanner';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import ForDrivers from './pages/ForDrivers';
import ForAdvertisers from './pages/ForAdvertisers';
import LeadForm from './pages/LeadForm';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import AppPrivacy from './pages/AppPrivacy';
import Terms from './pages/Terms';
import AdvertiserLogin from './pages/AdvertiserLogin';
import AdvertiserDashboard from './pages/AdvertiserDashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import FAQ from './pages/FAQ';
import PixelTest from './pages/PixelTest';
import AdminGeofences from './pages/AdminGeofences';
import AdminManualData from './pages/AdminManualData';
import AdminAdvertisers from './pages/AdminAdvertisers';
import AdminLeads from './pages/AdminLeads';
import AdminIdleHeatmap from './pages/AdminIdleHeatmap';
import AdminSyncHealth from './pages/AdminSyncHealth';
import AdminBloom from './pages/AdminBloom';
import BloomRules from './pages/BloomRules';
import BloomCallback from './pages/BloomCallback';
import InstagramConnect from './pages/InstagramConnect';
import GiveawaySignUp from './pages/GiveawaySignUp';
import GiveawayConfirm from './pages/GiveawayConfirm';
import GiveawayRules from './pages/GiveawayRules';
import AdminGiveaways from './pages/AdminGiveaways';
import { PageReferrerPolicy } from './components/PageReferrerPolicy';

const SiteFrame = ({ children }) => {
  const { pathname } = useLocation();
  if (pathname === '/connect/instagram' || pathname.startsWith('/giveaway/')) return <main>{children}</main>;
  return <><PromoBanner /><Navbar /><main className="min-h-screen">{children}</main><Footer /></>;
};

// Serves a static HTML file from /public for extensionless App Store URLs
// (advectigroup.com/support and /marketing must not show a blank screen).
const StaticPage = ({ file }) => {
  React.useEffect(() => { window.location.replace(file); }, [file]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageReferrerPolicy />
        <SiteFrame>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/for-drivers" element={<ForDrivers />} />
            <Route path="/for-advertisers" element={<ForAdvertisers />} />
            <Route path="/get-started" element={<LeadForm />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/app-privacy" element={<AppPrivacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/support" element={<StaticPage file="/support.html" />} />
            <Route path="/marketing" element={<StaticPage file="/marketing.html" />} />
            <Route path="/advertiser-login" element={<AdvertiserLogin />} />
            <Route path="/dashboard" element={<AdvertiserDashboard />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/pixel-test" element={<PixelTest />} />
            <Route path="/admin/geofences" element={<AdminGeofences />} />
            <Route path="/admin/manual-data" element={<AdminManualData />} />
            <Route path="/admin/advertisers" element={<AdminAdvertisers />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/admin/idle-heatmap" element={<AdminIdleHeatmap />} />
            <Route path="/admin/sync-health" element={<AdminSyncHealth />} />
            <Route path="/admin/bloom" element={<AdminBloom />} />
            <Route path="/bloom/rules" element={<BloomRules />} />
            <Route path="/bloom/callback" element={<BloomCallback />} />
            <Route path="/connect/instagram" element={<InstagramConnect />} />
            <Route path="/giveaway/:slug" element={<GiveawaySignUp />} />
            <Route path="/giveaway/:slug/confirm" element={<GiveawayConfirm />} />
            <Route path="/giveaway/:slug/rules" element={<GiveawayRules />} />
            <Route path="/admin/giveaways" element={<AdminGiveaways />} />
          </Routes>
        </SiteFrame>
      </BrowserRouter>
    </div>
  );
}

export default App;
